/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import {
  INVOICE_ESTIMATION,
  INVOICE_LESSOR_FIRST_INVOICE,
  INVOICE_MANAGEMENT,
  INVOICE_OWNER,
  INVOICE_PROFORMA,
  INVOICE_RENT,
  INVOICE_SALE,
  INVOICE_TENANT,
  INVOICE_TENANT_FIRST_INVOICE
} from '../../enums/InvoiceTypes.mjs'
import InvoiceTemplateField from '../fields/InvoiceTemplateField'
import { Stack } from '@mantine/core'
import { useSettingsContext } from '../SettingsProvider'

function InvoiceTemplateList () {
  const intl = useIntl()
  const { settings } = useSettingsContext()
  return (
    <Stack>
      <InvoiceTemplateField
        accept={settings.INVOICE_TEMPLATE_FILE_TYPES}
        maxSize={settings.INVOICE_TEMPLATE_MAX_UPLOAD_SIZE}
        item={{
          title: intl.formatMessage({
            id: 'generic_invoice_template',
            defaultMessage: 'Modèle de facture générique'
          }),
          description: intl.formatMessage({
            id: 'generic_invoice_template_desc',
            defaultMessage: 'Ce modèle générique est utilisé pour générer toutes les autres factures (ex: charge locataire ou propriétaire).'
          }),
          type: 'generic'
        }}
      />
      <InvoiceTemplateField
        accept={settings.INVOICE_TEMPLATE_FILE_TYPES}
        maxSize={settings.INVOICE_TEMPLATE_MAX_UPLOAD_SIZE}
        item={{
          title: intl.formatMessage({
            id: 'tenant_first_invoice_template',
            defaultMessage: 'Modèle de facture des honoraires de location du locataire'
          }),
          description: intl.formatMessage({
            id: 'tenant_first_invoice_template_desc',
            defaultMessage: 'Ce modèle est utilisé pour générer la facture initiale du locataire, à la création du bail de location.'
          }),
          type: INVOICE_TENANT_FIRST_INVOICE
        }}
      />
      <InvoiceTemplateField
        accept={settings.INVOICE_TEMPLATE_FILE_TYPES}
        maxSize={settings.INVOICE_TEMPLATE_MAX_UPLOAD_SIZE}
        item={{
          title: intl.formatMessage({
            id: 'lessor_first_invoice_template',
            defaultMessage: 'Modèle de facture des honoraires de location du bailleur'
          }),
          description: intl.formatMessage({
            id: 'lessor_first_invoice_template_desc',
            defaultMessage: 'Ce modèle est utilisé pour générer la facture initiale du bailleur, à la création du bail de location.'
          }),
          type: INVOICE_LESSOR_FIRST_INVOICE
        }}
      />
      <InvoiceTemplateField
        accept={settings.INVOICE_TEMPLATE_FILE_TYPES}
        maxSize={settings.INVOICE_TEMPLATE_MAX_UPLOAD_SIZE}
        item={{
          title: intl.formatMessage({
            id: 'owner_invoice_template',
            defaultMessage: 'Modèle de facture propriétaire'
          }),
          description: intl.formatMessage({
            id: 'owner_invoice_template_desc',
            defaultMessage: 'Ce modèle est utilisé pour générer les factures adressées au propriétaire.'
          }),
          type: INVOICE_OWNER
        }}
      />
      <InvoiceTemplateField
        accept={settings.INVOICE_TEMPLATE_FILE_TYPES}
        maxSize={settings.INVOICE_TEMPLATE_MAX_UPLOAD_SIZE}
        item={{
          title: intl.formatMessage({
            id: 'management_invoice_template',
            defaultMessage: 'Modèle de facture de gestion'
          }),
          description: intl.formatMessage({
            id: 'management_invoice_template_desc',
            defaultMessage: 'Ce modèle est utilisé pour générer tous les mois, la facture des honoraires de gestion, destinée au bailleur.'
          }),
          type: INVOICE_MANAGEMENT
        }}
      />
      <InvoiceTemplateField
        accept={settings.INVOICE_TEMPLATE_FILE_TYPES}
        maxSize={settings.INVOICE_TEMPLATE_MAX_UPLOAD_SIZE}
        item={{
          title: intl.formatMessage({
            id: 'tenant_invoice_template',
            defaultMessage: 'Modèle de facture locataire'
          }),
          description: intl.formatMessage({
            id: 'tenant_invoice_template_desc',
            defaultMessage: 'Ce modèle est utilisé pour générer les factures adressées au locataire.'
          }),
          type: INVOICE_TENANT
        }}
      />
      <InvoiceTemplateField
        accept={settings.INVOICE_TEMPLATE_FILE_TYPES}
        maxSize={settings.INVOICE_TEMPLATE_MAX_UPLOAD_SIZE}
        item={{
          title: intl.formatMessage({
            id: 'rent_invoice_template',
            defaultMessage: 'Modèle de facture de loyer'
          }),
          description: intl.formatMessage({
            id: 'rent_invoice_template_desc',
            defaultMessage: 'Ce modèle est utilisé pour générer tous les mois, la facture de loyer destinée au locataire.'
          }),
          type: INVOICE_RENT
        }}
      />
      <InvoiceTemplateField
        accept={settings.INVOICE_TEMPLATE_FILE_TYPES}
        maxSize={settings.INVOICE_TEMPLATE_MAX_UPLOAD_SIZE}
        item={{
          title: intl.formatMessage({
            id: 'sale_invoice_template',
            defaultMessage: 'Modèle de facture de vente'
          }),
          description: intl.formatMessage({
            id: 'sale_invoice_template_desc',
            defaultMessage: 'Ce modèle est utilisé pour générer les factures de vente.'
          }),
          type: INVOICE_SALE
        }}
      />
      <InvoiceTemplateField
        accept={settings.INVOICE_TEMPLATE_FILE_TYPES}
        maxSize={settings.INVOICE_TEMPLATE_MAX_UPLOAD_SIZE}
        item={{
          title: intl.formatMessage({
            id: 'proforma_invoice_template',
            defaultMessage: 'Modèle de facture proforma'
          }),
          description: intl.formatMessage({
            id: 'proforma_invoice_template_desc',
            defaultMessage: 'Ce modèle est utilisé pour générer les factures proforma.'
          }),
          type: INVOICE_PROFORMA
        }}
      />
      <InvoiceTemplateField
        accept={settings.INVOICE_TEMPLATE_FILE_TYPES}
        maxSize={settings.INVOICE_TEMPLATE_MAX_UPLOAD_SIZE}
        item={{
          title: intl.formatMessage({
            id: 'estimation_invoice_template',
            defaultMessage: 'Modèle de facture d\'estimation'
          }),
          description: intl.formatMessage({
            id: 'estimation_invoice_template_desc',
            defaultMessage: 'Ce modèle est utilisé pour générer les factures d\'estimation.'
          }),
          type: INVOICE_ESTIMATION
        }}
      />
    </Stack>
  )
}

export default InvoiceTemplateList
